var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDislikeSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 17,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.894a1.666 1.666 0 0 0 1.667 1.667h4.206a.15.15 0 0 1 .134.067.17.17 0 0 1 0 .146 5.76 5.76 0 0 0-.347 2.94c.393 1.4 1.22 1.8 1.873 1.714a1.334 1.334 0 0 0 1.134-1.387c0-1.813 1.42-3.813 2.667-4.707a.34.34 0 0 0 .146-.28v-6.74a.33.33 0 0 0-.267-.326l-.666-.134c-.89-.206-1.8-.305-2.714-.293H3.5c-1.307 0-1.5.707-1.5 1.147-.002.23.051.459.153.666a1.5 1.5 0 0 0-.666 2A1.507 1.507 0 0 0 .82 7.428 1.66 1.66 0 0 0 0 8.894M12.5 9.04a.666.666 0 0 0 .667.668h2.166A.667.667 0 0 0 16 9.04V1.708a.666.666 0 0 0-.667-.667h-2.166a.667.667 0 0 0-.667.667zm1-6.146a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 17,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.894a1.666 1.666 0 0 0 1.667 1.667h4.206a.15.15 0 0 1 .134.067.17.17 0 0 1 0 .146 5.76 5.76 0 0 0-.347 2.94c.393 1.4 1.22 1.8 1.873 1.714a1.334 1.334 0 0 0 1.134-1.387c0-1.813 1.42-3.813 2.667-4.707a.34.34 0 0 0 .146-.28v-6.74a.33.33 0 0 0-.267-.326l-.666-.134c-.89-.206-1.8-.305-2.714-.293H3.5c-1.307 0-1.5.707-1.5 1.147-.002.23.051.459.153.666a1.5 1.5 0 0 0-.666 2A1.507 1.507 0 0 0 .82 7.428 1.66 1.66 0 0 0 0 8.894M12.5 9.04a.666.666 0 0 0 .667.668h2.166A.667.667 0 0 0 16 9.04V1.708a.666.666 0 0 0-.667-.667h-2.166a.667.667 0 0 0-.667.667zm1-6.146a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }))));
});
export default SvgIconDislikeSolid;
export const raw = __webpack_public_path__ + "static/media/IconDislikeSolid.f8be442fe849516245a314ce15f78c51.svg";